import { Types } from 'mongoose';

const commonVoiceItemSettings = {
  idIvrStep: -1,
  idIvrStepGroup: 1, // podemos deixar pra um segundo momento
  idIvrGrammar: null,
  idIvrStatus: null,
  qtScoreMin: null,
  qtMaxRepeat: null,
  qtMinDigitsDtmf: null,
  qtMaxDigitsDtmf: null,
  qtSecTimeoutDtmf: null,
  isExternalTransferCall: false,
  mustNextStepWithIvrData: false,
  mustConfirmOrderIfOccursHangup: false, // podemos deixar pra um segundo momento
  isNoInputValidAnswer: false,
  mustValidateIvrResultInDatabase: false,
  mustGenerateCodeTransfer: false,
  idIvrDataConfig: -1, // podemos deixar pra um segundo momento
  isCpc: false,
  isActive: false,
};

export const voiceItemTransferirRamalInternoExternoSettings = {
  ...commonVoiceItemSettings,
  idIvrStepType: 5,
  deIvrStep: 'Digite a descrição',
  deScriptTts: 'Sem publicação',
  isExternalTransferCall: false,
  nuTransfer: '0',
  mustGenerateCodeTransfer: false,
  codeIvrStepExternal: '', // ==> opcional
  isCpc: false,
};

export const voiceItemTTSAudioSettings = {
  ...commonVoiceItemSettings,
  idIvrStepType: 6,
  deIvrStep: 'Digite a descrição',
  deScriptTts: 'Sem publicação',
  idIvrStatus: null,
  codeIvrStepExternal: '', // ==> opcional
  isCpc: false,
};

export const voiceItemConfirmarVendaSettings = {
  ...commonVoiceItemSettings,
  idIvrStepType: 7,
  deIvrStep: 'Digite a descrição',
  deScriptTts: 'Sem publicação', // => opcional
  codeIvrStepExternal: '', // ==> opcional
  isCpc: false,
};

export const voiceItemTTSAudioASRSettings = {
  ...commonVoiceItemSettings,
  idIvrStepType: 9,
  deIvrStep: 'Digite a descrição',
  deScriptTts: 'Aqui vai o texto para verbalização',
  idIvrGrammar: null,
  deScriptTtsRepeat: '', // ==> opcional
  qtMaxRepeat: 1,
  qtScoreMin: 60,
  idIvrStatus: null,
  mustValidateIvrResultInDatabase: false,
  nmFieldValidateIvrResultInDatabase: '', // ==> opcional
  nmIvrData: '', // ==> opcional
  mustNextStepWithIvrData: false,
  codeIvrStepExternal: '', // ==> opcional
  isCpc: false,
  nmPathFileIpbxBeforeNextStep: '', // ==> opcional - podemos deixar pra um segundo momento
};

export const voiceItemFinalizarAtendimentoSettings = {
  ...commonVoiceItemSettings,
  idIvrStepType: 10,
  deIvrStep: 'Digite a descrição',
  deScriptTts: 'Sem publicação',
  idIvrStatus: null,
  codeIvrStepExternal: '', // ==> opcional
  isCpc: false,
};

export const voiceItemTransferirRamalLocalizadorVendedorSettings = {
  ...commonVoiceItemSettings,
  idIvrStepType: 11,
  deIvrStep: 'Digite a descrição',
  deScriptTts: 'Sem publicação',
  mustGenerateCodeTransfer: false,
  codeIvrStepExternal: '', // ==> opcional
  isCpc: false,
};

export const voiceItemAgendarMailingSettings = {
  ...commonVoiceItemSettings,
  idIvrStepType: 12,
  deIvrStep: 'Digite a descrição',
  deScriptTts: 'Sem publicação',
  idIvrStatus: null,
  codeIvrStepExternal: '', // ==> opcional
  isCpc: false,
};

export const voiceItemTTSAudioDTMFSettings = {
  ...commonVoiceItemSettings,
  idIvrStepType: 13,
  deIvrStep: 'Digite a descrição',
  deScriptTts: 'Sem publicação',
  deScriptTtsRepeat: '', // ==> opcional
  qtMaxRepeat: 1,
  qtMinDigitsDtmf: 1,
  qtMaxDigitsDtmf: 1,
  qtSecTimeoutDtmf: 5,
  deAnswerAllowed: '', // ==> opcional
  idIvrStatus: null,
  mustValidateIvrResultInDatabase: false,
  nmFieldValidateIvrResultInDatabase: '', // ==> opcional
  nmIvrData: '', // ==> opcional
  mustNextStepWithIvrData: false,
  codeIvrStepExternal: '', // ==> opcional
  isCpc: false,
  deScriptTtsBeforeNextStep: '', // ==> opcional - podemos deixar pra um segundo momento
};

export const voiceItemWebApiListSettings = {
  ...commonVoiceItemSettings,
  idIvrStepType: 14,
  deIvrStep: 'Digite a descrição',
  deUrlWebApi: '',
  deParametersWebApi: {},
  idIvrWebApi: '',
  codeIvrStepExternal: '', // => opcional
  isCpc: false,
};

export const voiceItemSMSSettings = {
  ...commonVoiceItemSettings,
  idIvrStepType: 15,
  deIvrStep: 'Digite a descrição',
  deMessageSms: 'Sem publicação',
  codeIvrStepExternal: '', // => opcional
  isCpc: false,
};

const voiceItemSettings = {
  VoiceTransferirRamalInternoExterno:
    voiceItemTransferirRamalInternoExternoSettings,
  VoiceTTSAudio: voiceItemTTSAudioSettings,
  VoiceConfirmarVenda: voiceItemConfirmarVendaSettings,
  VoiceTTSAudioASR: voiceItemTTSAudioASRSettings,
  VoiceFinalizarAtendimento: voiceItemFinalizarAtendimentoSettings,
  VoiceTransferirRamalLocalizadorVendedor:
    voiceItemTransferirRamalLocalizadorVendedorSettings,
  VoiceAgendarMailing: voiceItemAgendarMailingSettings,
  VoiceTTSAudioDTMF: voiceItemTTSAudioDTMFSettings,
  VoiceWebApiList: voiceItemWebApiListSettings,
  VoiceSMS: voiceItemSMSSettings,
};

const voiceItemTitle = {
  VoiceTransferirRamalInternoExterno: 'Transf. Ramal',
  VoiceTTSAudio: 'Tocar Áudio',
  VoiceConfirmarVenda: 'Venda',
  VoiceTTSAudioASR: 'Áudio + Recon. de Voz',
  VoiceFinalizarAtendimento: 'Finalizar Atendimento',
  VoiceTransferirRamalLocalizadorVendedor: 'Trans. Operador',
  VoiceAgendarMailing: 'Agendar Ligação',
  VoiceTTSAudioDTMF: 'Áudio + Reconh. de Dígitos',
  VoiceWebApiList: 'API',
  VoiceSMS: 'Enviar SMS',
};

const getMenuItems = (type) => {
  if (type === 'VoiceSMS') {
    return [
      {
        _id: Types.ObjectId().toString(),
        description: 'NEXT_STEP',
        require_connection: true,
      },
      {
        _id: Types.ObjectId().toString(),
        description: 'ERROR',
        require_connection: true,
      },
    ];
  }

  if (type === 'VoiceTTSAudioDTMF') {
    return [
      {
        _id: Types.ObjectId().toString(),
        description: 'LIMIT_EXCEEDED',
        require_connection: true,
      },
    ];
  }

  return [
    {
      _id: Types.ObjectId().toString(),
      description: '',
    },
  ];
};

const getVoiceItemSettings = (type, position) => {
  const commonSettings = {
    positionOnScreen: position,
    type,
  };

  if (!voiceItemSettings[type]) {
    console.log(`Erro na criação do item. Tipo: '${type}' não encontrado.`);
    return null;
  }

  let defaultMenuItems = [];

  const isMenuItem = [
    'VoiceTTSAudioASR',
    'VoiceTTSAudioDTMF',
    'VoiceSMS',
  ].includes(type);

  if (isMenuItem) {
    defaultMenuItems = getMenuItems(type);
  }

  const itemConfig = {
    ...commonSettings,
    title: voiceItemTitle[type],
    voiceSettings: voiceItemSettings[type],
    menuItems: defaultMenuItems,
  };

  return itemConfig;
};

export { getVoiceItemSettings };
